import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/auth-service';
import { NavigationHistoryService } from '../core/navigation-history.service';
import { NavigationEnd, Router } from '@angular/router';
import { RoleGuardService } from '../role-guard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { filter } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrl: './title-bar.component.scss'
})
export class TitleBarComponent implements OnInit {

  username: string;
  canViewUpjar: boolean;
  currentPage: string;

  constructor(private authService: AuthService, private navigationHistory: NavigationHistoryService,
    private router: Router, private roleGuardService: RoleGuardService,
    private modalService: NgbModal, private location: Location) {
  }

  public ngOnInit(): void {
    this.username = this.authService.getUser()?.name;
    this.canViewUpjar = this.roleGuardService.hasRole(AuthService.viewUpjar);
  }
  
  
    ngAfterViewInit(): void {
      setTimeout(() => {
        this.currentPage = this.location.path();
      });
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.currentPage = this.location.path();
        });
    }

  refresh(): void {
    this.clearIds();
    this.router.navigate(['/']).then(() => {
      window.location.reload();
    });
  }

  clearIds() {
    this.navigationHistory.setId(null);
  }
  
  logout() {
    this.clearIds();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      keyboard: false,
      backdrop: 'static',
      centered: true,
      size: 'md',
    });
    modalRef.componentInstance.title = 'Logout';
    modalRef.componentInstance.message = `Are you sure that you want to log out?`;
    modalRef.componentInstance.failButton = 'No';
    modalRef.componentInstance.successButton = 'Yes';

    modalRef.result.then(
      () => {
        this.authService.logout();
      },
      () => {
        this.modalService.dismissAll();
      }
    );
  }

  closeMenu() {
    this.clearIds();
    const event = new MouseEvent('click', {bubbles: true});
    document.getElementsByClassName('menu-btn')[0].dispatchEvent(event);
  }
}